export default __webpack_public_path__ + "dist/media/Send-and-negotiate.cfdabab7.svg";